/* aethero-deliver-time.js */
(function () {
  if (window.AetheroDelivery && window.AetheroDelivery._initialized) {
    console.log('[DELIVERY] already initialized, skipping');
    return;
  }
  window.AetheroDelivery = window.AetheroDelivery || {};
  window.AetheroDelivery._initialized = true;

  const LOG = (...a) => console.log('[DELIVERY]', ...a);
  const ERR = (...a) => console.error('[DELIVERY]', ...a);

  // Wait helper
  function waitFor(selector, { attempts = 60, interval = 200 } = {}) {
    return new Promise((resolve, reject) => {
      let tries = 0;
      const t = setInterval(() => {
        const el = document.querySelector(selector);
        if (el) { clearInterval(t); resolve(el); return; }
        if (++tries >= attempts) { clearInterval(t); reject(new Error(`Timeout waiting for ${selector}`)); }
      }, interval);
    });
  }

  // Parse helper
  function parseJSONScript(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      const data = JSON.parse(el.textContent.trim());
      LOG(`parsed #${id}`, data);
      return data;
    } catch (e) {
      ERR(`JSON parse failed for #${id}:`, e);
      return null;
    }
  }

  // Build a unified map from any available source
  function loadUnifiedMap() {
    // 1) Preferred: single map
    const map = parseJSONScript('ae-delivery-map');
    if (map && map.variants) {
      LOG('using ae-delivery-map');
      return {
        product_delivery: map.product_delivery || '',
        variants: map.variants || {}
      };
    }

    // 2) Fallback: combine older blobs
    const inv = parseJSONScript('ae-inventory');            // { "id": { qty, ... } }
    const deli = parseJSONScript('ae-variant-delivery');    // { "id": "DODACÍ HODNOTA" | [..] }
    if (inv || deli) {
      LOG('using fallback (#ae-inventory + #ae-variant-delivery)');
      const variants = {};
      const ids = new Set([
        ...Object.keys(inv || {}),
        ...Object.keys(deli || {})
      ]);
      ids.forEach(id => {
        variants[id] = {
          qty: inv && inv[id] ? inv[id].qty ?? inv[id].inventory_quantity ?? 0 : 0,
          v_delivery: deli ? deli[id] ?? '' : ''
        };
      });
      return {
        product_delivery: '', // we don’t have product-level fallback here unless you also add it
        variants
      };
    }

    // Nothing found
    return null;
  }

  const clean = (val) => {
    if (Array.isArray(val)) return val.filter(Boolean).join(', ');
    if (val == null) return '';
    return String(val).replace(/^\s*\[|\]\s*$/g, '').replace(/"/g, '').trim();
  };

  const getVariantFromURL = () => {
    const v = new URLSearchParams(location.search).get('variant');
    LOG('URL variant =', v);
    return v && /^\d+$/.test(v) ? v : null;
  };

  const getVariantSelect = () => {
    const sel = document.querySelector('form[action*="/cart/add"] select[name="id"], select[name="id"]');
    LOG('found select?', !!sel, sel);
    return sel;
  };

  function computeText(map, variantId) {
    const entry = map.variants && map.variants[variantId];
    LOG('computeText for', variantId, 'entry:', entry);
    const productDp = clean(map.product_delivery);
    const vDp = entry ? clean(entry.v_delivery) : '';
    const qty = entry ? Number(entry.qty || 0) : 0;

    const dp = vDp || productDp;
    if (qty > 0) return 'Skladem';
    if (dp === 'RYCHLÝ DODAVATEL') return 'Skladem';
    if (dp === 'Zakázková výroba') return 'Zakázková výroba';
    if (dp) return 'DORUČÍME: ' + dp;
    return '';
  }

  function makeUpdater(targetEl, mapRef) {
    return function update() {
      // if JSON appeared later, refresh map
      if (!mapRef.map) {
        mapRef.map = loadUnifiedMap();
        LOG('late map load →', !!mapRef.map);
      }
      if (!mapRef.map) {
        LOG('no map yet; skipping update');
        return;
      }

      const fromURL = getVariantFromURL();
      const sel = getVariantSelect();
      const currentId = fromURL || (sel && sel.value);
      LOG('update() currentId =', currentId);
      if (!currentId) return;

      const newText = computeText(mapRef.map, currentId);
      LOG('newText =', newText);
      targetEl.textContent = newText;
    };
  }

  async function init() {
    LOG('init start');

    // Wait for the target element (handles section lazy-load)
    const target = await waitFor('#delivery-time-display').catch(e => { ERR(e.message); return null; });
    if (!target) return;

    // Try to load any available JSON blobs
    let mapRef = { map: loadUnifiedMap() };
    if (!mapRef.map) {
      LOG('no delivery JSON found yet; will keep watching…');
    }

    const update = makeUpdater(target, mapRef);

    // Initial
    update();

    // Listen for likely variant-change signals
    ['variant:change','variant:changed','product:variant-change','theme:variant:change','changed.option']
      .forEach(evt => {
        document.addEventListener(evt, (e) => {
          LOG('event fired:', evt, e && e.detail);
          update();
        }, { passive: true });
      });

    // Select change fallback
    const sel = getVariantSelect();
    if (sel) {
      sel.addEventListener('change', (e) => {
        LOG('select changed →', e.target && e.target.value);
        update();
      }, { passive: true });
    }

    // URL changes
    window.addEventListener('popstate', () => { LOG('popstate'); update(); });

    let lastSearch = location.search;
    setInterval(() => {
      if (location.search !== lastSearch) {
        LOG('URL search changed', lastSearch, '→', location.search);
        lastSearch = location.search;
        update();
      }
    }, 500);

    // If the product section re-renders, re-run once and try re-reading JSON
    document.addEventListener('shopify:section:load', () => { LOG('section reload'); mapRef.map = loadUnifiedMap(); update(); });

    // MutationObserver: if any of our JSON scripts appear later, re-try
    const mo = new MutationObserver(() => {
      const hasAny = document.getElementById('ae-delivery-map')
                   || document.getElementById('ae-inventory')
                   || document.getElementById('ae-variant-delivery');
      if (hasAny && !mapRef.map) {
        LOG('observer saw JSON appear; loading…');
        mapRef.map = loadUnifiedMap();
        update();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    LOG('init complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
